<div class="avatar-inner">
  <div *ngIf="!!image; else textTemplate" class="avatar-image-wrapper">
    <img class="avatar-image" [alt]="fullName" [src]="imageSrc"/>
  </div>

  <ng-template #textTemplate>
    <div class="avatar-text">{{ initials }}</div>
  </ng-template>
</div>